import React from 'react';
import AccountSelect from './AccountSelect';
var AccountTile = function (_a) {
    var id = _a.id, account = _a.account, label = _a.label;
    return (React.createElement(AccountSelect, { id: id, accounts: [account], value: account.accountId, label: label }));
};
export default AccountTile;
//# sourceMappingURL=AccountTile.js.map